import Axios from 'axios'
import config from './config'
import { addChildClientHeader } from './client-scope'

const authApiUrls = {
  remote: config.authRemoteApiUrl,
  local: config.authLocalApiUrl
}

let runtime = {
  applyLoginResponse: null,
  handleAuthenticationFailure: null,
}

let refreshPromise = null

const configureAuthenticatedApi = handlers => {
  runtime = {
    ...runtime,
    ...handlers,
  }
}

const callAuthenticatedApi = async ({ apiSource, apiKey, options, includeChildClientId = true, apiMode }) => {
  const execute = async key => {
    const headers = {
      'x-api-key': key,
      'Content-type': 'application/json',
      ...(apiMode !== undefined ? { 'x-mode': apiMode } : {})
    }

    options.headers = includeChildClientId ? addChildClientHeader(headers) : headers
    options.withCredentials = true

    const response = await Axios(options)
    return response.data
  }

  try {
    return await execute(apiKey)
  }
  catch (err) {
    if (!isAuthenticationError(err)) throw err

    const refreshedKey = await refreshLoginKey(apiSource)
    if (!refreshedKey) throw err

    return await execute(refreshedKey)
  }
}

export {
  callAuthenticatedApi,
  configureAuthenticatedApi,
}

const isAuthenticationError = err => {
  const error = err?.response?.data?.error

  return error?.error_code === 'AUTHENTICATION_FAILED'
    || error?.error_type === 'authentication'
    || error?.type === 'AuthenticationError'
}

const refreshLoginKey = async apiSource => {
  if (!refreshPromise) {
    refreshPromise = (async () => {
      try {
        const response = await Axios({
          method: 'GET',
          url: `${authApiUrls[apiSource]}/checkLoginToken`,
          withCredentials: true
        })

        const loginResponse = response.data

        if (loginResponse?.authenticated && loginResponse?.key) {
          await runtime.applyLoginResponse?.(loginResponse, { preserveSelectedClient: true })
          return loginResponse.key
        }

        await runtime.handleAuthenticationFailure?.()
        return null
      }
      catch (err) {
        await runtime.handleAuthenticationFailure?.()
        return null
      }
      finally {
        refreshPromise = null
      }
    })()
  }

  return await refreshPromise
}
